<form class="example-form mb-0">
  <mat-form-field appearance="outline" class="w-100 mb-0 search-field">
    <mat-label>Cerca cliente...</mat-label>
    <input
      type="text"
      placeholder="Cerca per nome..."
      aria-label="Company"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix>search</mat-icon>
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option) {
      <mat-option 
        [value]="option"
        (onSelectionChange)="onOptionSelected($event, option)">
        {{option}}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
